import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { AttachmentNodeView } from './AttachmentNodeView';
export const Attachment = Node.create({
    name: 'attachment',
    inline: false,
    group: 'block',
    draggable: true,
    addOptions() {
        return {
            HTMLAttributes: {},
            attachments: [],
        };
    },
    addAttributes() {
        return {
            attachment: {
                default: undefined,
                rendered: false,
            },
            id: {
                default: undefined,
                rendered: false,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'attachment[data-type=attachment]',
                getAttrs: dom => {
                    var _a;
                    if (typeof dom === 'string')
                        return {};
                    const element = dom;
                    const id = element.getAttribute('data-id');
                    const attachment = (_a = this.options.attachments) === null || _a === void 0 ? void 0 : _a.find(e => e.id === id);
                    if (!attachment && !id)
                        return {};
                    return {
                        id,
                        attachment,
                    };
                },
            },
        ];
    },
    renderHTML({ node }) {
        const { attachment, id } = node.attrs;
        if (!attachment && !id)
            return ['div'];
        return [
            'attachment',
            {
                'data-type': 'attachment',
                'data-id': id || (attachment === null || attachment === void 0 ? void 0 : attachment.id),
            },
        ];
    },
    addNodeView() {
        return ReactNodeViewRenderer(AttachmentNodeView);
    },
    addCommands() {
        return {
            setAttachment: attrs => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs,
                });
            },
        };
    },
});
//# sourceMappingURL=index.js.map